import script from "./NavControl.vue?vue&type=script&setup=true&lang=js"
export * from "./NavControl.vue?vue&type=script&setup=true&lang=js"

import "./NavControl.vue?vue&type=style&index=0&id=564f28ac&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-564f28ac"]])

export default __exports__